import Vue from 'vue'

import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
const userInfoStr = YJ_REGION_STORAGE.getItem('userInfo')
const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
const state = {
  userInfo: userInfo,
  menus: YJ_REGION_STORAGE.getItem('menus') ? JSON.parse(YJ_REGION_STORAGE.getItem('menus')) : '',
  isAdmin: false,
  roleId: userInfo.roles && userInfo.roles.length ? userInfo.roles[0].id : '',
  randomStr: Math.random().toString(36).substr(2),
  showVerity: false,
}

Vue.prototype.$schoolId = state.userInfo.schoolType === 1 ? state.userInfo.regionId : state.userInfo.schoolId
Vue.prototype.$schoolType = state.userInfo.schoolType

export default {
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/vuex/modules/login/index.js